/**
 * Confirmación de mayoría de edad (18+) de THCC.
 *
 * Abre como modal el <dialog id="thcc-edad"> (snippets/thcc-verificacion-edad.liquid) una vez por visitante:
 * la confirmación se recuerda 30 días en localStorage. El contenido de la página ya está en el HTML; este
 * módulo solo abre el aviso. No se abre a buscadores ni a Lighthouse, y Escape no lo cierra.
 */

const CLAVE = 'thcc_edad_ok';
const VIGENCIA_MS = 30 * 24 * 60 * 60 * 1000;
const ROBOTS = /bot|crawl|spider|lighthouse|slurp|mediapartners|pagespeed|headlesschrome/i;

/** @returns {boolean} true si la confirmación guardada sigue vigente */
function yaConfirmo() {
  try {
    const guardado = Number(localStorage.getItem(CLAVE));
    return guardado > 0 && Date.now() - guardado < VIGENCIA_MS;
  } catch {
    return false;
  }
}

function recordarConfirmacion() {
  try {
    localStorage.setItem(CLAVE, String(Date.now()));
  } catch {
    // Sin almacenamiento: el aviso volverá a salir en la siguiente página.
  }
}

function iniciar() {
  const dialogo = document.getElementById('thcc-edad');
  if (!(dialogo instanceof HTMLDialogElement)) return;
  if (ROBOTS.test(navigator.userAgent) || yaConfirmo()) return;

  let confirmado = false;

  // Escape dispara "cancel": se anula. Si el navegador cierra igual (p. ej. segunda pulsación), se reabre.
  dialogo.addEventListener('cancel', (evento) => evento.preventDefault());
  dialogo.addEventListener('close', () => {
    if (!confirmado) dialogo.showModal();
  });

  dialogo.querySelector('[data-thcc-edad-ok]')?.addEventListener('click', () => {
    confirmado = true;
    recordarConfirmacion();
    dialogo.close();
  });

  dialogo.showModal();
  dialogo.querySelector('[data-thcc-edad-ok]')?.focus();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', iniciar, { once: true });
} else {
  iniciar();
}
